// @ts-nocheck
import { forwardRef } from "react";
import { Modal, Spin } from "antd";
import { h } from "preact";
import { useEffect, useImperativeHandle, useState } from "preact/hooks";
import BaseForm from "../../../../components/form";
import { useForm } from "react-hook-form";
import {
  CONFIRM_SPARE_DEVICE,
  GET,
  GET_ADDRESS_CUSTOMER,
  GET_MAINTENANCES_IMAGES,
  POST,
} from "../../../../services";
import { useMessage } from "../../../../hooks/useMessage";
import { IPropsModal } from "../../interfaces/modal";
import { DEFAULT_VALUE } from "../../constants/default-values";
import { FORM_EDIT } from "../../constants/forms";
import { useGetDeliveryOptions } from "../../hook/useGetDeliveryOptions";
import { ContainerImageAndForm } from "../../../repair/styled";
import { ShowImage } from "../../../../components/image";
import { IReponse } from "../../../../services/interface";

const EditDataSpare = (props: any, ref) => {
  const { onCallbackEdit } = props;
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const { openMessage } = useMessage();
  const [optionAddress, setOptionAddress] = useState([]);
  const [stateMaintenancesImage, setStateMaintenancesImage] = useState([]);
  const { control, setValue, getValues, reset, handleSubmit } = useForm({
    defaultValues: { ...DEFAULT_VALUE, delivery: "DL-003" },
  });

  const { deliveryOptions, loading: loadingDelivery } = useGetDeliveryOptions();

  const useGetMaintenancesImages = async (maintainId: string) => {
    try {
      const res: IReponse = await GET(
        `${GET_MAINTENANCES_IMAGES}?maintainId=${maintainId}&imageType=REQUEST-PURCHASE`
      );
      const { images } = res.result;
      setStateMaintenancesImage(images);
    } catch (error) {
      console.log(error);
    }
  };

  useImperativeHandle(ref, () => ({
    async openModal(e) {
      try {
        const [res] = await Promise.all([
          GET(GET_ADDRESS_CUSTOMER(e.customerCode)),
          useGetMaintenancesImages(e.maintainId),
        ]);
        const { address } = res.result;
        for (const key in e) {
          const element = e[key];
          if (key in DEFAULT_VALUE) {
            setValue(key as keyof typeof DEFAULT_VALUE, element);
          }
        }
        setOptionAddress(address);
        setVisible(true);
      } catch (error) {
        console.log(error);
      }
    },
  }));

  useEffect(() => {
    !visible && reset();
  }, [visible]);

  const onConfirm = async () => {
    try {
      setLoading(true);
      const {
        maintainId,
        maintainSpareId,
        deviceSpareId,
        delivery,
        trackingNo,
        deviceId,
        customerCode,
      } = getValues();
      const res = await POST(CONFIRM_SPARE_DEVICE, {
        maintainId,
        maintainSpareId,
        deviceSpareId,
        delivery,
        trackingNo,
        deviceId,
        customerCode,
      });
      if (!res.success) {
        return;
      }
      setLoading(false);
      openMessage("success", res.message);
      onCallbackEdit && onCallbackEdit(getValues());
      setVisible(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      openMessage("error", error.message);
    }
  };

  return (
    <Modal
      width={700}
      title="คอนเฟิร์มเครื่องสแปร์"
      visible={visible}
      okText={"บันทึก"}
      cancelText={"ยกเลิก"}
      centered
      onOk={handleSubmit(onConfirm)}
      onCancel={() => setVisible(false)}
      confirmLoading={loading}
    >
      <Spin spinning={loadingDelivery}>
        <BaseForm
          control={control}
          forms={FORM_EDIT({ optionAddress, deliveryOptions })}
          setValue={setValue}
          getValues={getValues}
        />
        <ContainerImageAndForm style={{ margin: "1rem 0" }}>
          <ShowImage image={stateMaintenancesImage} />
        </ContainerImageAndForm>
      </Spin>
    </Modal>
  );
};

export const EditData = forwardRef(EditDataSpare);
